import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateGenerativeTaskMutationVariables = Types.Exact<{
  input: Types.CreateGenerativeTaskInput;
}>;


export type CreateGenerativeTaskMutation = { createGenerativeTask?: { generativeTask?: { id: string, error?: { errorCode: Types.GenerativeTaskErrorCodeEnum, message?: string | null } | null } | null } | null };


export const CreateGenerativeTaskDocument = /*#__PURE__*/ gql`
    mutation createGenerativeTask($input: CreateGenerativeTaskInput!) {
  createGenerativeTask(data: $input) {
    generativeTask {
      id
      error {
        errorCode
        message
      }
    }
  }
}
    `;

export function useCreateGenerativeTaskMutation() {
  return Urql.useMutation<CreateGenerativeTaskMutation, CreateGenerativeTaskMutationVariables>(CreateGenerativeTaskDocument);
};